import axios from "../axiosInstance"
import { arquivosTemporarios } from "../shared/utils/Endpoints"

class ArquivosTemporariosService {
    async enviar(arquivo) {
        const formData = new FormData();
        formData.append("arquivo", arquivo);

        return await axios.post(arquivosTemporarios, formData, {
            headers: { "Content-Type": "multipart/form-data" }
        });
    }

    async baixar(guid) {
        return await axios.get(arquivosTemporarios, {
            params: {
                guid: guid
            },
            responseType: "blob"
        });
    }

    async excluir(guid) {
        return await axios.delete(arquivosTemporarios, {
            params: {
                guid: guid
            },
            handleError: false
        });
    }
}

export default new ArquivosTemporariosService();